<template>
  <div class="notice-card cm-card cm-shadow--1dp notice-card__warn">
    <div class="cm-card__supporting-text">
      <strong>{{data.title || title}}</strong>
      <p>{{data.summary || summary}}</p>
    </div>
    <div class="cm-card__actions cm-card--border" v-if="data.actions || actions">
      <a
        class="cm-button cm-button--colored"
        v-for="(value, index) in data.actions || actions"
        :key="index"
        @click="value.fn">{{value.name}}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notice',
  props: {
    data: Object,
    title: String,
    summary: String,
    actions: Array
  }
}
</script>

<style lang="sass">
.notice-card.cm-card
  min-height: auto
  margin: 16px 0
  border-width: 2px 0 0 0
  border-style: solid
  padding: 16px 24px
  &.notice-card__warn
    border-color: #d69999
    background: #faf2f2 none
  .cm-card__supporting-text
    line-height: 24px
    height: auto
    margin: 0
    strong
      font-weight: 600
      line-height: 28px
      display: block
      color: rgba(0,0,0,0.82)
  .cm-card__actions
    text-align: right
</style>



// WEBPACK FOOTER //
// src/components/Notice.vue